import { render, staticRenderFns } from "./manage-menu.vue?vue&type=template&id=601c332b&"
import script from "./manage-menu.vue?vue&type=script&lang=js&"
export * from "./manage-menu.vue?vue&type=script&lang=js&"
import style0 from "./manage-menu.vue?vue&type=style&index=0&id=601c332b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports